<template>
  <div>
    <v-row justify="center">
      <v-col cols="12" class="pt-16">
        <v-container>
          <back-button @click.native="$router.go(-1)"></back-button>
          <v-row>
            <v-col cols="12" lg="6">
              <h3 class="mb-8 home-header-3">
                Which vaccination are you booking for?
              </h3>
              <p class="mb-8 home-text-2">
                Dose 2 of Meningitis B should be received 28 days after Dose 1.<br />
                Please schedule your Dose 2 appointment accordingly and bring your Meningitis B vaccination record card to the appointment.
              </p>
              <v-radio-group
                v-model="meningitisBDose"
                v-on:change="saveMeningitisBDose"
                class="mb-4"
              >
                <v-radio
                  v-on:keyup.native.enter="
                    meningitisBDose = 'MEN_B_DOSE_1';
                    saveMeningitisBDose();
                  "
                  label="Dose 1 Meningitis-B"
                  color="#006078"
                  class="ml-4 px-8 py-4 black--text"
                  value="MEN_B_DOSE_1"
                  :ripple="false"
                ></v-radio>
                <v-radio
                  v-on:keyup.native.enter="
                    meningitisBDose = 'MEN_B_DOSE_2';
                    saveMeningitisBDose();
                  "
                  label="Dose 2 Meningitis-B"
                  color="#006078"
                  class="ml-4 px-8 py-4 black--text"
                  value="MEN_B_DOSE_2"
                  :ripple="false"
                ></v-radio>
              </v-radio-group>
              <v-btn
                @click="onAfterContinueClicked"
                class="v-btn--primary"
                :disabled="!meningitisBDose"
              >
                Continue
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue';
import BackButton from '@/components/BackButton';

export default Vue.extend({
  components: {
    BackButton
  },
  name: 'StepMeningitisB3',
  data: () => ({
    meningitisBDose: null
  }),
  methods: {
    saveMeningitisBDose() {
      this.$store.commit('setBookingTypes', [this.meningitisBDose]);
      this.$store.commit('setMeningitisBDose', this.meningitisBDose);
    },
    onAfterContinueClicked() {
      this.$gtag.event(`Meningitis B dose selected` + `${this.meningitisBDose}`, {})

      this.$router.push('/booking/eligible').catch(() => {});
    }
  }
});
</script>
